document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form.cart');
  const checkoutButton = document.querySelector('[name="checkout"]');

  // 各フィールド
  const pdR = document.getElementById('pd-r');
  const pdL = document.getElementById('pd-l');
  const cylR = document.getElementById('cyl-r');
  const cylL = document.getElementById('cyl-l');
  const axisR = document.getElementById('axis-r');
  const axisL = document.getElementById('axis-l');
  const sphR = document.getElementById('sph-r');
  const sphL = document.getElementById('sph-l');
  const kyumenNote = document.getElementById('kyumendosu-note');

  const requiredFieldsBase = [pdR, pdL];
  const astigmatismFields = [cylR, cylL, axisR, axisL];
  const sphFields = [sphR, sphL];

  // 各種セレクタ・ラジオ
  const aboutDosuSelect = document.getElementById('about-dosu');
  const oneMonthRadios = document.querySelectorAll('[name="attributes[1ヶ月以内か]"]');

  // ▼ NEW: 乱視はセレクト化 & 要素名変更
  const ranshiRSelect = document.getElementById('ranshi-r'); // 値: 'あり' | 'なし' | ''
  const ranshiLSelect = document.getElementById('ranshi-l'); // 値: 'あり' | 'なし' | ''

  const astigmatRismInfos = document.querySelectorAll('.astigmatism-info.--right');
  const astigmatLismInfos = document.querySelectorAll('.astigmatism-info.--left');

  // 表示制御用セクション
  const dosuInputSection = document.querySelector('.dosu-input');
  const dosuMonthSection = document.querySelector('.dosu-month');
  const dosuShopSection = document.querySelector('.dosu-shop');

  // ▼ NEW: レンズタイプ（単焦点／遠近両用）
  const lensTypeSection = document.getElementById('lens-type');
  const lensTypeRadios = document.querySelectorAll('[name="lens-type-choice"]');
  const lensTypeValue = document.getElementById('lens-type-value');
  const enkinNotice = document.getElementById('enkin-notice');
  const enkinContactLink = document.getElementById('enkin-contact-link');
  const additionalButtons = document.querySelector('.cart__footer__additional');

  // ▼ NEW: ＋度数確認モーダル
  const plusModal = document.getElementById('plus-dosu-modal');
  const plusModalCheck = document.getElementById('plus-dosu-check');
  const plusModalOk = document.getElementById('plus-dosu-ok');
  const plusConfirmedInput = document.getElementById('plus-dosu-confirmed');

  // ▼ NEW: カート内容のチェック（オプションのみ注文／サングラス単体＋カラーレンズ）
  const cartRuleBox = document.getElementById('cart-rule-error');
  const lineItemsWrap = document.querySelector('[data-line-items]');
  let cartRuleConfig = {};
  try {
    cartRuleConfig = JSON.parse(document.getElementById('cart-rule-config').textContent);
  } catch (err) {
    cartRuleConfig = {};
  }
  const extraOptionIds = (cartRuleConfig.extra_option_product_ids || []).map(Number);
  const sunglassBlockedIds = (cartRuleConfig.sunglass_blocked_product_ids || []).map(Number);
  let cartRuleError = null; // null | 'option-only' | 'sunglass-color'

  // 値取得
  function getDosuChoice() {
    return aboutDosuSelect ? aboutDosuSelect.value : null;
  }
  function getOneMonthChoice() {
    const selected = Array.from(oneMonthRadios).find(r => r.checked);
    return selected ? selected.value : null;
  }
  function getLensTypeChoice() {
    const selected = Array.from(lensTypeRadios).find(r => r.checked);
    return selected ? selected.value : null;
  }
  // 度付き注文（レンズタイプの選択が必要）かどうか
  function needsLensType() {
    const dosuChoice = getDosuChoice();
    return dosuChoice === '度数入力する' || dosuChoice === '前回購入時の度数に合わせる';
  }
  function isEnkinSelected() {
    return needsLensType() && getLensTypeChoice() === '遠近両用';
  }

  // 表示制御：度数
  function handleDosuDisplay() {
    const dosuChoice = getDosuChoice();
    const oneMonthChoice = getOneMonthChoice();
    const showLensType = needsLensType();
    const enkin = isEnkinSelected();

    if (lensTypeSection) lensTypeSection.style.display = showLensType ? '' : 'none';
    if (enkinNotice) enkinNotice.style.display = enkin ? '' : 'none';
    updateAdditionalButtons();
    if (lensTypeValue) lensTypeValue.value = showLensType ? (getLensTypeChoice() || '') : '';

    if (dosuInputSection) dosuInputSection.style.display = (dosuChoice === '度数入力する' && !enkin) ? '' : 'none';
    if (dosuMonthSection) dosuMonthSection.style.display = (dosuChoice === '前回購入時の度数に合わせる' && !enkin) ? '' : 'none';
    if (dosuShopSection) dosuShopSection.style.display =
      (dosuChoice === '前回購入時の度数に合わせる' && oneMonthChoice === 'はい' && !enkin) ? '' : 'none';

    if (dosuChoice === '度なし作成希望' || dosuChoice === '度数入力する') {
      oneMonthRadios.forEach(radio => (radio.checked = false));
    }
  }

  // Apple Pay 等の追加決済ボタンはカートのチェックを通らないため、決済させない状態では隠す
  function updateAdditionalButtons() {
    if (additionalButtons) additionalButtons.style.display = (isEnkinSelected() || cartRuleError) ? 'none' : '';
  }

  // カート内容の判定
  function isOptionItem(item) {
    return item.product_type === cartRuleConfig.option_type || extraOptionIds.includes(Number(item.product_id));
  }
  function evaluateCartRules(items) {
    if (!items || !items.length) return null;
    const frames = items.filter(item => !isOptionItem(item));
    if (frames.length === 0) return 'option-only';
    const sunglassOnly = frames.every(item => item.product_type === cartRuleConfig.sunglass_type);
    if (sunglassOnly && items.some(item => sunglassBlockedIds.includes(Number(item.product_id)))) {
      return 'sunglass-color';
    }
    return null;
  }
  function renderCartRuleError() {
    if (!cartRuleBox) return;
    cartRuleBox.textContent = '';
    if (!cartRuleError) {
      cartRuleBox.hidden = true;
      return;
    }
    const title = document.createElement('p');
    title.className = 'cart-rule-error__title';
    const text = document.createElement('p');
    text.className = 'cart-rule-error__text';
    if (cartRuleError === 'option-only') {
      title.textContent = 'フレームをお選びください';
      text.textContent = 'レンズオプションのみでのご注文はいただけません。メガネまたはサングラスのフレームを選んでカートに追加してください。';
      cartRuleBox.append(title, text);
      if (cartRuleConfig.frames_url) {
        const link = document.createElement('a');
        link.className = 'btn btn--primary';
        link.href = cartRuleConfig.frames_url;
        link.textContent = 'フレームを選ぶ';
        cartRuleBox.appendChild(link);
      }
    } else {
      title.textContent = 'サングラスには「カラーレンズ（2,200円）」をお付けできません';
      text.textContent = '度付きサングラスでカラーレンズをご希望の場合は、「サングラス度付変更オプション（3,200円〜）」をお選びください。カート内の「カラーレンズ」を削除してからお手続きください。';
      cartRuleBox.append(title, text);
    }
    cartRuleBox.hidden = false;
  }
  function applyCartRules(items) {
    cartRuleError = evaluateCartRules(items);
    renderCartRuleError();
    updateAdditionalButtons();
    validateFields();
  }
  // 数量変更・削除はAjaxで行われるため、カート内容を取り直して再判定
  async function refreshCartRules() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      applyCartRules(cart.items || []);
    } catch (err) {
      // 取得に失敗した場合は直前の判定を維持
    }
  }

  // 表示制御：乱視セクション（セレクト対応）
  function handleAstigmatismDisplay() {
    const rightVal = ranshiRSelect ? ranshiRSelect.value : '';
    const leftVal  = ranshiLSelect ? ranshiLSelect.value : '';

    const rightShow = rightVal === 'あり';
    const leftShow  = leftVal === 'あり';
    const rightClear = rightVal === 'なし';
    const leftClear  = leftVal === 'なし';

    astigmatRismInfos.forEach(el => el.style.display = rightShow ? '' : 'none');
    astigmatLismInfos.forEach(el => el.style.display = leftShow ? '' : 'none');

    if (rightClear) {
      if (cylR) cylR.value = '';
      if (axisR) axisR.value = '';
    }
    if (leftClear) {
      if (cylL) cylL.value = '';
      if (axisL) axisL.value = '';
    }
  }

  // 表示制御：球面度数（±の表示）
  // 選択肢は全角「＋」表記のため、半角・全角の両方を＋度数として扱う
  function isPlusValue(value) {
    return typeof value === 'string' && /^[+＋]/.test(value.trim());
  }
  function hasPlusSph() {
    return getDosuChoice() === '度数入力する' && !isEnkinSelected() &&
      [sphR, sphL].some(el => el && isPlusValue(el.value));
  }
  function handleKyumenNoteDisplay() {
    const hasPositive = [sphR, sphL].some(el => el && isPlusValue(el.value));
    if (kyumenNote) kyumenNote.style.display = hasPositive ? '' : 'none';
  }

  // ＋度数確認：確認済みの度数の組み合わせを保持し、度数が変わったら再確認させる
  let plusConfirmedSignature = null;
  let pendingCheckout = false;

  function currentSphSignature() {
    return (sphR ? sphR.value : '') + '|' + (sphL ? sphL.value : '');
  }
  function needsPlusConfirm() {
    return hasPlusSph() && plusConfirmedSignature !== currentSphSignature();
  }
  function syncPlusConfirmedInput() {
    if (!plusConfirmedInput) return;
    plusConfirmedInput.value = (hasPlusSph() && plusConfirmedSignature === currentSphSignature())
      ? '確認済み（R: ' + sphR.value + ' / L: ' + sphL.value + '）'
      : '';
  }
  function openPlusModal(fromCheckout) {
    if (!plusModal) return;
    pendingCheckout = !!fromCheckout;
    [['r', sphR], ['l', sphL]].forEach(([key, el]) => {
      const dd = plusModal.querySelector('[data-plus-dosu-value="' + key + '"]');
      if (!dd || !el) return;
      dd.textContent = el.value;
      dd.classList.toggle('is-plus', isPlusValue(el.value));
    });
    if (plusModalCheck) plusModalCheck.checked = false;
    if (plusModalOk) plusModalOk.disabled = true;
    plusModal.hidden = false;
    document.body.classList.add('plus-dosu-modal-open');
    if (plusModalCheck) plusModalCheck.focus();
  }
  function closePlusModal() {
    if (!plusModal) return;
    plusModal.hidden = true;
    document.body.classList.remove('plus-dosu-modal-open');
  }

  // バリデーション（セレクト対応）
  function validateFields() {
    const dosuChoice = getDosuChoice();
    const oneMonthChoice = getOneMonthChoice();

    const rightAstigmatism = (ranshiRSelect && ranshiRSelect.value === 'あり');
    const leftAstigmatism  = (ranshiLSelect && ranshiLSelect.value === 'あり');

    let allFilled = true;
    let fieldsToCheck = [];

    if (!dosuChoice) {
      allFilled = false;
    }

    // ▼ NEW: カート内容のエラーがある場合は決済不可
    if (cartRuleError) {
      allFilled = false;
    }

    // ▼ NEW: 度付き注文ではレンズタイプ必須。遠近両用は問い合わせ対応のため決済不可
    if (needsLensType() && !getLensTypeChoice()) {
      allFilled = false;
    }
    if (isEnkinSelected()) {
      allFilled = false;
    }

    if (dosuChoice === '前回購入時の度数に合わせる' && !oneMonthChoice && !isEnkinSelected()) {
      allFilled = false;
    }

    if (dosuChoice === '度数入力する' && !isEnkinSelected()) {
      fieldsToCheck = [pdR, pdL];
      if (rightAstigmatism) fieldsToCheck.push(cylR, axisR);
      if (leftAstigmatism) fieldsToCheck.push(cylL, axisL);
    }

    fieldsToCheck.forEach(field => {
      if (!field) return;
      if (!field.value) {
        allFilled = false;
        field.style.border = '2px solid red';
      } else {
        field.style.border = '';
      }
    });

    if (checkoutButton) checkoutButton.disabled = !allFilled;
    return allFilled;
  }

  // イベント登録
  const allChangeElements = [
    ...requiredFieldsBase,
    ...astigmatismFields,
    ...oneMonthRadios,
    aboutDosuSelect,
    // ▼ NEW: セレクトを監視対象に追加
    ranshiRSelect,
    ranshiLSelect,
    ...lensTypeRadios
  ].filter(Boolean); // nullガード

  allChangeElements.forEach(el => {
    el.addEventListener('change', () => {
      handleDosuDisplay();
      handleAstigmatismDisplay();
      handleKyumenNoteDisplay();
      syncPlusConfirmedInput();
      validateFields();
    });
  });

  sphFields.filter(Boolean).forEach(el => {
    el.addEventListener('change', () => {
      handleKyumenNoteDisplay();
      syncPlusConfirmedInput();
      validateFields();
      // ＋度数が選ばれたら、その場で確認を取る
      if (isPlusValue(el.value) && needsPlusConfirm()) {
        openPlusModal(false);
      }
    });
  });

  // ＋度数確認モーダルの操作
  if (plusModal) {
    if (plusModalCheck && plusModalOk) {
      plusModalCheck.addEventListener('change', () => {
        plusModalOk.disabled = !plusModalCheck.checked;
      });
    }
    if (plusModalOk) {
      plusModalOk.addEventListener('click', () => {
        if (plusModalCheck && !plusModalCheck.checked) return;
        plusConfirmedSignature = currentSphSignature();
        syncPlusConfirmedInput();
        closePlusModal();
        if (pendingCheckout && form && checkoutButton) {
          pendingCheckout = false;
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(checkoutButton);
          } else {
            checkoutButton.click();
          }
        }
      });
    }
    // 「度数を修正する」／背景クリック：確認せずに閉じて度数欄へ戻す
    plusModal.querySelectorAll('[data-plus-dosu-cancel]').forEach(el => {
      el.addEventListener('click', () => {
        pendingCheckout = false;
        closePlusModal();
        const target = [sphR, sphL].find(s => s && isPlusValue(s.value));
        if (target) target.focus();
      });
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !plusModal.hidden) {
        pendingCheckout = false;
        closePlusModal();
      }
    });
  }

  // 遠近両用：カート内の商品情報を付けて問い合わせフォームへ
  function extractColor(item) {
    if (item.variant_title) return item.variant_title;
    // 商品名の「C-1」「C-6/M」等のカラー番号
    const m = (item.product_title || '').match(/\bC-\s?\d+(?:\/[A-Za-z]+)?/);
    return m ? m[0] : '';
  }
  function extractSize(item) {
    const m = (item.product_title || '').match(/\d{2}□\d{2}-\d{3}/);
    return m ? m[0] : '';
  }
  if (enkinContactLink) {
    enkinContactLink.addEventListener('click', async e => {
      e.preventDefault();
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const params = new URLSearchParams();
      params.set('lens', 'enkin');
      try {
        const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
        const cart = await res.json();
        (cart.items || []).forEach(item => {
          params.append('p_name', item.product_title || '');
          params.append('p_url', location.origin + (item.url || ''));
          params.append('p_id', String(item.product_id || ''));
          params.append('p_variant', String(item.variant_id || ''));
          params.append('p_color', extractColor(item));
          params.append('p_size', extractSize(item));
          params.append('p_qty', String(item.quantity || ''));
        });
      } catch (err) {
        // カート取得に失敗しても問い合わせフォームへは遷移させる
      }
      location.href = enkinContactLink.getAttribute('href').split('?')[0] + '?' + params.toString() + '#contact-us-page';
    });
  }

  // 初期化
  handleDosuDisplay();
  handleAstigmatismDisplay();
  handleKyumenNoteDisplay();
  syncPlusConfirmedInput();
  applyCartRules(cartRuleConfig.items || []);

  if (lineItemsWrap && 'MutationObserver' in window) {
    let cartRuleTimer = null;
    new MutationObserver(() => {
      clearTimeout(cartRuleTimer);
      cartRuleTimer = setTimeout(refreshCartRules, 200);
    }).observe(lineItemsWrap, { childList: true, subtree: true });
  }

  // フォーム送信前チェック
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!validateFields()) {
        e.preventDefault();
        if (cartRuleError === 'option-only') {
          alert('レンズオプションのみでのご注文はいただけません。フレームをお選びください。');
        } else if (cartRuleError === 'sunglass-color') {
          alert('サングラスには「カラーレンズ（2,200円）」をお付けできません。カート内の「カラーレンズ」を削除してください。');
        } else if (isEnkinSelected()) {
          alert('遠近両用レンズをご希望の場合は、「問い合わせへ進む」からご相談ください。');
        } else {
          alert('必要項目を入力するか、条件に合う選択肢を選んでください。');
        }
        return;
      }
      // ▼ NEW: ＋度数が未確認のまま決済へ進もうとした場合は確認モーダルを表示
      const isCheckout = !e.submitter || e.submitter.name === 'checkout';
      if (isCheckout && needsPlusConfirm()) {
        e.preventDefault();
        openPlusModal(true);
      }
    });
  }
});
